import { useEffect, useState } from 'react';

import { Typography } from '@mui/joy';

const FlexibleAppButtons = () => {
  const [isAndroid, setIsAndroid] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    if (/Android/i.test(userAgent)) {
      setIsAndroid(true);
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
      setIsIOS(true);
      //TODO: Change to app clip url
    }
  }, []);

  if (isAndroid) {
    return (
      <Typography level="body3">
        & for Android will be re-released with all new features in Fall 2023
      </Typography>
    );
  }

  if (isIOS) {
    setTimeout(() => {
      window.location.href = 'https://apps.apple.com/us/app/and/id1556305221';
    }, 1000);
    return (
      <Typography level="body3">Redirecting you to the App Store...</Typography>
    );
  }

  return null;
};

export default FlexibleAppButtons;
